module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1200@2x-f57efb9b7428ee1ebfcbde60e3b911f9.jpg";